import axios from 'axios';
//import interceptorsSetup from './util/axios-interceptor';
import interceptorsSetup from './util/axios-interceptor2';
import settings from '../static/settings.json';

export {API, settings}; 

//var value= 'https://sidra.fcm.com.mx/logout';

//export const 
const API = axios.create({
  baseURL: settings.baseURL,  // dev
});


interceptorsSetup(API);
